import styles from './FormSection.module.css';
import React, {useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {Input, Section, Select, Button} from '@telegram-apps/telegram-ui';


// Get today's date in YYYY-MM-DD format
const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// Get date one week from now
const getDatePlusDays = (dateString: string, days: number) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + days);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};



function FormSection() {
    const navigate = useNavigate();
    const [category, setCategory] = useState('bike-bags');
    const [startDate, setStartDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState(getDatePlusDays(getTodayDate(), 7));

    const handleSearch = () => {
        const params = new URLSearchParams({
            category: category,
            start: startDate,
            end: endDate,
        });
        navigate(`/catalog?${params.toString()}`);
    };

    return (
        <Section>
            <Select
                header="Инвентарь"
                name="equipment"
                className={styles.input}
                value={category}
                onChange={(e) => setCategory(e.target.value)}
            >
                <option value="bike-bags">Велочемодан</option>
                <option value="swimming-wetsuits">Гидрокостюм</option>
                <option value="road-bikes">Шоссейный велосипед</option>
            </Select>
            <Input
                header="Начало"
                name={"from"}
                type={"date"}
                className={styles.input}
                value={startDate}
                onChange={(e) => {
                    const newStartDate = e.target.value;
                    setStartDate(newStartDate);
                }}
            />
            <Input
                header="Окончание"
                name={"to"}
                type={"date"}
                className={styles.input}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
            />
            <Button size="l" stretched onClick={handleSearch}>
                Найти
            </Button>

        </Section>
    );
}

export default FormSection;
